import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosInstance';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FiCheckCircle, FiAlertTriangle, FiLoader } from 'react-icons/fi';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid or missing verification token.');
      return;
    }
    axiosInstance
      .get(`/auth/verify-email?token=${token}`)
      .then(() => {
        setStatus('success');
        setMessage('Your email has been verified! You can now continue.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(
          err.response?.data?.message || 'Verification failed or link expired.'
        );
      });
  }, [token]);

  const getStatusIcon = () => {
    switch (status) {
      case 'verifying':
        return <FiLoader className="animate-spin text-5xl text-blue-400 mb-6" />;
      case 'success':
        return <FiCheckCircle className="text-5xl text-green-400 mb-6" />;
      case 'error':
        return <FiAlertTriangle className="text-5xl text-red-400 mb-6" />;
      default:
        return null;
    }
  };

  const getCardColor = () => {
    switch (status) {
      case 'verifying':
        return 'bg-gray-800 border-gray-700';
      case 'success':
        return 'bg-gray-800 border-green-700';
      case 'error':
        return 'bg-gray-800 border-red-700';
      default:
        return 'bg-gray-800 border-gray-700';
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-900 to-gray-800 px-4">
      <div className={`p-8 rounded-lg shadow-2xl border ${getCardColor()} max-w-md w-full`}>
        <div className="flex flex-col items-center text-center">
          {getStatusIcon()}
          
          <h2 className="text-3xl font-bold mb-4 text-white">
            {status === 'verifying'
              ? 'Verifying Email'
              : status === 'success'
              ? 'Email Verified!'
              : 'Verification Failed'}
          </h2>
          
          <p className={`mb-8 ${
            status === 'success' 
              ? 'text-green-300' 
              : status === 'error' 
              ? 'text-red-300' 
              : 'text-gray-300'
          }`}>
            {message}
          </p>
          
          {status !== 'verifying' && (
            <button
              onClick={() => navigate('/signin')}
              className="w-full px-4 py-3 bg-blue-600 rounded-md hover:bg-blue-700 text-white transition-colors"
            >
              {status === 'success' ? 'Continue to Sign In' : 'Back to Sign In'}
            </button>
          )}
          
          {status === 'error' && (
            <p className="mt-6 text-sm text-gray-400">
              If you're experiencing issues, you can request a new verification email from the sign-in page.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail; 